
import styled from 'styled-components'


// RankingMunicipio2
export  const DivCenterVertical = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
`;
export const ListConteiner = styled.div`
    width: 80vw;
    border-pacing: 5px;
    width: 90vw;
    /* width:100%; */
    max-width: 600px;
    min-width: 400px;

`

// ComoEFeitoOsCalculos
export const Observacao = styled.p`
    width: 100%;
    font-size: 1.4rem;
    font-weight: bold;
    padding: 10px 5px;
    margin-bottom:10px;
    text-align: center;
    color:#525f6b;
    max-width: 600px;

    img {
        width: 60%;
        padding: 5px;
        margin-top: 20px;
    }

    ul {
        text-align: left;
        padding: 20px 0;
    }
    li {
        padding: 10px 10px;
    }
`;

// BlocoMunicipios
export const RankingBloco = styled.div`
    /*&==RankingBloco*/
    width: 100%;
    min-height: 100px;

    padding: 10px 20px;
    /* padding: 10px 5px 10px 0px; */
    background-color: #382673;
    box-shadow: 4px 4px 4px rgb(0 0 0 / 30%);
    border-radius: 8px;
    margin-bottom: 15px;
    /* distribuir horizontal*/
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-around;
    align-content: center;

    /*Bloco 1*/
    &:nth-child(1) {
        background-color: var(--cor-bg-bloco1);
    }

    &:nth-child(1) .ranking-icone-pos2 {
        background-color: var(--cor-ico-pos1);
    }

    /*Bloco 2*/
    &:nth-child(2) {
        background-color: var(--cor-bg-bloco2);
    }

    &:nth-child(2) .ranking-icone-pos2 {
        background-color: var(--cor-ico-pos2);
    }

    /*Bloco 3*/
    &:nth-child(3) {
        background-color: var(--cor-bg-bloco3);
    }

    &:nth-child(3) .ranking-icone-pos2 {
        background-color: var(--cor-ico-pos3);
    }
`

export const Icone = styled.div`
    display: flex;
    justify-content: center;
    /*width: 90px;*/
    margin-right: 10px;
    height: max-content;
    transform: scale(1.3);
    div {   border-radius: 50%;
        width: 40px;
        height: 40px;
        background-color: var(--cor-ico-pos);
        border: 1px solid #494949;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 2.5rem;
        line-height: 12px;
        /* or 48% */
        display: flex;
        align-items: center;
        /* text/m/titulo */
        color: #F9F6EE;
        /*border: 1px solid #494949;*/
        text-shadow: -1px 0 #494949, 0 1px #494949, 1px 0 #494949, 0 -1px #494949;
    }
`

export const Nome = styled.p`
    font-family: Poppins;
    text-align: left;
    font-size: 20px;
    letter-spacing: 0;
    font-weight: bold;
    font-family: Poppins;
    text-align: center;
    font-size: 2rem;
    letter-spacing: 0;
    font-weight: bold;
`

export const Dados = styled.div`
    margin-top:5px;
    p {
        font-family: Poppins;
        text-align: left;
        font-size: 1.5rem;
        padding:2px;
    }
`

export const Pontos = styled.div`
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;

    font-style: normal;
    font-size: 1.6rem;

    .valor{
        font-size: 2.3rem;
        font-weight: bold;
        padding: 5px 0;
        color: #FFFFFF;

    }

    .moeda {
        margin-left: 0.5rem;
    }
`
